import { SectionCard, QueryState, EmptyState } from '@/components';
import { useQuery } from '@/lib/useQuery';
import DataTable from '../../components/DataTable';
import { formatDateTime, humanize } from '../../lib/format';
import { usePlatformCan } from '../../lib/access';

/** Platform audit events for one merchant (needs audit.view). */
export default function AuditTab({ merchant: m }) {
  const canAudit = usePlatformCan('audit.view');
  const events = useQuery('platformAudit', { company: m.slug, limit: 200 }, { select: (r) => r.data, enabled: canAudit });
  if (!canAudit) return <EmptyState title="The audit log needs the audit.view permission" />;
  return (
    <div className="space-y-4">
      <SectionCard title={`Audit trail · ${m.slug}`}>
        <QueryState query={events}>
          {(rows) => (rows.length ? (
            <DataTable
              data={rows}
              columns={[
                { key: 'at', label: 'When', render: (r) => formatDateTime(r.at) },
                { key: 'action', label: 'Action', render: (r) => <span className="font-medium">{humanize(r.action)}</span> },
                { key: 'actor', label: 'Actor' },
                { key: 'target', label: 'Target', hideOnMobile: true, render: (r) => <span className="break-all">{r.target}</span> },

              ]}
            />
          ) : <EmptyState title="No audit events for this merchant yet" />)}
        </QueryState>
      </SectionCard>
    </div>
  );
}
